import { FJCommonAPIClass } from '@src/core/network/FJCommonAPI.ts';
import FJNetworkManager from '@src/core/FJNetworkManager';
import FJUtil from '@src/util/FJUtil';

class FJYoutubeAPIClass extends FJCommonAPIClass {
    private _downloadAbortController: AbortController | null;
    private _eventId: string | null;
    constructor() {
        super();
        this._downloadAbortController = null;
        this._eventId = null;
    }
    // 从YouTube链接中获取视频的时长，宽高
    public async getYoutubeLinkInfoWithServerless(youtubeUrl: string) {
        const url = this._baseUrl + 'v1/ai/get-ytb-mt';
        const formData = new FormData();
        formData.append('url', youtubeUrl);
        this._addTeamIdToFormData(formData);
        const headers = {};
        FJNetworkManager._addUUID(headers);
        const res = await fetch(url, { method: 'POST', body: formData, headers: headers });
        const { code, data } = await res.json();
        if (code !== 200) {
            throw new Error(code.toString());
        }
        const { duration, resolution, title, thumbnail_url, download_scheme } = data;
        const [width, height] = resolution.split('x');
        return {
            title,
            thumbnail_url,
            duration,
            width: Number(width),
            height: Number(height),
            downloadScheme: download_scheme,
        };
    }
    public async downloadYoutubeVideo(youtubeUrl: string, youtubeDownloadScheme: string) {
        this.cancelDownload();
        this._downloadAbortController = new AbortController();
        let url: string = '';
        // url = this._baseUrl + 'v1/ai/download-youtube-video';
        if (youtubeDownloadScheme === 'SERVICE_PROVIDER') {
            // TODO 服务商的方案
            url = this._baseUrl + 'v1/ai/download-youtube-video';
        } else {
            // TODO 我们自己的方案
            url = this._baseUrl + 'v1/ai/down-ytb-video';
        }
        const formData = new FormData();
        formData.append('url', youtubeUrl);
        this._addTeamIdToFormData(formData);
        const headers = {};
        FJNetworkManager._addUUID(headers);
        const res = await fetch(url, {
            method: 'POST',
            body: formData,
            signal: this._downloadAbortController.signal,
            headers: headers,
        });
        const { code, data } = await res.json();
        if (code !== 200) {
            this._downloadError();
            throw new Error(code.toString());
        }
        if (!this._downloadAbortController) {
            throw new Error('Canceled');
        }
        this._eventId = data.event_id;
        const result = await this._loopDownload(this._eventId || '').catch(e => {
            this._downloadError();
            throw e;
        });
        this._eventId = null;
        return result;
    }

    private async _loopDownload(eventId: string) {
        let done = false;
        let result = null;

        while (!done) {
            if (!this._eventId || this._eventId !== eventId) {
                done = true;
                throw new Error('Canceled');
            }
            const { job_state, out_put } = await FJNetworkManager.getNewTaskState(eventId);
            switch (job_state) {
                case 'waiting':
                case 'processing':
                    break;
                case 'canceled':
                    done = true;
                    throw new Error('Canceled');
                case 'failed':
                    done = true;
                    throw new Error('generate failed');
                case 'succeeded':
                    done = true;
                    result = out_put[0]?.result;
                    break;
                default:
                    break;
            }
            await FJUtil.wait(3);
            if (!this._eventId || this._eventId !== eventId) {
                done = true;
                throw new Error('Canceled');
            }
        }
        if (!result) {
            throw new Error('Download failed');
        }

        return result;
    }

    public cancelDownload() {
        this._downloadAbortController?.abort();
        this._downloadAbortController = null;
        this._eventId = null;
    }

    private _downloadError() {
        this._downloadAbortController = null;
        this._eventId = null;
    }

    async fetchYoutubeUserProfile(accessToken: string) {
        const apiUrl = `https://www.googleapis.com/youtube/v3/channels?part=snippet&mine=true&access_token=${accessToken}`;

        try {
            const response = await fetch(apiUrl);
            if (!response.ok) {
                // 如果响应状态不是 2xx，则抛出错误
                const errorData = await response.json();
                throw new Error(`Failed to fetch YouTube profile: ${errorData.error.message}`);
            }

            const data = await response.json();

            // 检查 API 返回的数据结构是否符合预期
            if (data.items && data.items.length > 0) {
                const snippet = data.items[0].snippet;
                const profile = {
                    name: snippet.title,
                    avatar: snippet.thumbnails.default.url, // 或者使用 medium, high
                    // email 不是从这个端点返回的，需要另外的 scope 和 API
                };
                return profile;
            } else {
                throw new Error('No channel data found for the user.');
            }
        } catch (error) {
            console.error('Error fetching YouTube profile:', error);
            return null;
        }
    }
}
const _instance = new FJYoutubeAPIClass();
export default _instance;
